import { Paginated } from '../../common/pagination.js';
import { PaymentView } from '../../payment.js';
import { AdminPaymentQuery, RefundInput } from './schemas.js';
export const adminPaymentsRoutes = {
    payments: {
        method: 'GET',
        path: '/admin/payments',
        query: AdminPaymentQuery,
        response: Paginated(PaymentView),
    },
    refund: {
        method: 'POST',
        path: '/admin/payments/:paymentId/refund',
        body: RefundInput,
        response: PaymentView,
    },
};
//# sourceMappingURL=routes.js.map